var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.87 123.87"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.87 123.87H29.31V29.23L0 38.32v-20L51.23 0h2.64z",
    fill: "#fff"
  })));
}
Svg01.displayName = '01';
export default Svg01;